import React, { useContext, useRef, useState } from "react";
import axios from "axios";
import EmojiPicker from "emoji-picker-react";
import MoodIcon from "@mui/icons-material/Mood";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SendIcon from "@mui/icons-material/Send";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ImageIcon from "@mui/icons-material/Image";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { GlobalVariablesContext } from "../../../GlobalVariables";
import Buttons from "./Buttons";
import UploadProgress from "../Header/UploadProgress";
import Popup from "../../../UniversalCmpt/Popup";
import MicIcon from "@mui/icons-material/Mic";
import VoiceRecorder from "./VoiceRecorder";

function Footer() {

  const [input, setInput] = useState("");
  const [openEmojiPicker, setOpenEmojiPicker] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const { currentUser } = useContext(GlobalVariablesContext);
  const [isShowProgress, setIsShowProgress] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [isMicOpen, setMicOpen] = useState(false);
  const [popup, setPopup] = useState(false);
  const textarea = useRef();



  const handleEmojiSelect = (event, emojiObject) => {
    setInput((prevInput) => prevInput + emojiObject.emoji);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (window.innerWidth > 700 && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      } else if (e.shiftKey || window.innerWidth <= 700) {
        e.preventDefault();
        setInput((pre) => pre + "\n");
        autoEx();
      }
    }
  };

  const sendMessage = async () => {
    if (input.length > 0) {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer dummy_token",
        };

        if (currentUser.platform === 'instagram' || currentUser.platform === 'facebook' || currentUser.platform === 'page') {
          // Meta Send Message
          const senderId = currentUser.business_user_id || '17841463218981561';

          const payload = new FormData();
          payload.append('message', input);
          payload.append('message_type', 'text');
          payload.append('user_id', currentUser.phone);
          payload.append('conversation_id', currentUser.conversation_id);
          payload.append('sender', senderId);
          payload.append('recipient', currentUser.phone);
          payload.append('platform', currentUser.platform);

          setInput("");
          textarea.current.style.height = "4rem";
          await axios.post('https://jutiyapa.com/send_message/', payload);
        } else {
          // WhatsApp Send Message
          let sendingMessage = {
            profile_name: currentUser.name,
            message_text: input,
            phone_number: currentUser.phone,
            from_number: currentUser.wb_num,
          };
          setInput("");
          textarea.current.style.height = "4rem";
          await axios.post('https://casualfootwears.com/api/react_rooms_sendmsg/', sendingMessage, {
            headers,
          });
        }
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Failed to send message");
      }
    }
  };

  const autoEx = () => {
    textarea.current.style.height = "4rem";
    textarea.current.style.height =
      Math.min(textarea.current.scrollHeight, 120) + "px";
  };

  const sendVideo = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".mp4, .webp, .mov";

    fileInput.onchange = async (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        const formData = new FormData();

        if (currentUser.platform === 'instagram' || currentUser.platform === 'facebook' || currentUser.platform === 'page') {
          // Meta Flow: Upload -> Send
          formData.append('file', selectedFile);
          try {
            setIsShowProgress(true);
            const uploadRes = await axios.post('https://jutiyapa.com/upload_media/', formData, {
              onUploadProgress: (p) => setPercentage(Math.round((p.loaded * 100) / p.total))
            });

            const mediaUrl = uploadRes.data.media_file; // Assuming backend returns { media_file: ... }

            const sendMediaData = new FormData();
            const senderId = currentUser.business_user_id || '17841463218981561';
            sendMediaData.append('user_id', currentUser.phone);
            sendMediaData.append('conversation_id', currentUser.conversation_id);
            sendMediaData.append('media_url', mediaUrl);
            sendMediaData.append('media_type', 'video');
            sendMediaData.append('platform', currentUser.platform);
            sendMediaData.append('recipient', currentUser.phone);
            sendMediaData.append('sender', senderId);

            await axios.post('https://jutiyapa.com/send_media/', sendMediaData);
            setIsShowProgress(false);
          } catch (err) {
            console.error('Meta Video Upload Error', err);
            setIsShowProgress(false);
            setIsShowPopup(true);
          }
        } else {
          // WhatsApp Flow
          formData.append("video", selectedFile);
          formData.append("profile_name", currentUser.name);
          formData.append("phone_number", currentUser.phone);
          formData.append("from_number", currentUser.wb_num);

          axios.post('https://casualfootwears.com/api/upload_media_video/', formData, {
            onUploadProgress: (p) => {
              setIsShowProgress(true);
              setPercentage(Math.round((p.loaded * 100) / p.total));
            },
          })
            .then(() => setIsShowProgress(false))
            .catch((error) => {
              setIsShowProgress(false);
              setIsShowPopup(true);
              console.log("Error uploading video :: ", error);
            });
        }
      }
    };
    fileInput.click();
    setShowDropdown(false);
  };

  const sendDocument = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "application/pdf";
    fileInput.accept = "application/docx";

    fileInput.onchange = (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        const formData = new FormData();
        formData.append("document", selectedFile);
        formData.append("profile_name", currentUser.name);
        formData.append("phone_number", currentUser.phone);
        formData.append("from_number", currentUser.wb_num);

        axios
          .post('https://casualfootwears.com/api/upload_media_document/', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setIsShowProgress(true);
              setPercentage(percentCompleted);
            },
          })
          .then(() => {
            setIsShowProgress(false);
          })
          .catch((error) => {
            setIsShowProgress(false);
            setIsShowPopup(true);
            console.log("Error uploading vdieo :: ", error);
          });
      }
    };

    fileInput.click();
    setShowDropdown(false);
  };

  const sendImage = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".png, .jpeg, .jpg";

    fileInput.onchange = async (event) => {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        const formData = new FormData();

        if (currentUser.platform === 'instagram' || currentUser.platform === 'facebook' || currentUser.platform === 'page') {
          formData.append('file', selectedFile);
          try {
            setIsShowProgress(true);
            // Step 1: Upload
            const uploadRes = await axios.post('https://jutiyapa.com/upload_media/', formData, {
              onUploadProgress: (p) => setPercentage(Math.round((p.loaded * 100) / p.total))
            });

            // Step 2: Send
            // Ensure backend returns absolute URL or we prepend base if needed.
            const mediaUrl = uploadRes.data.media_file
              ? (uploadRes.data.media_file.startsWith('http') ? uploadRes.data.media_file : `https://jutiyapa.com${uploadRes.data.media_file}`)
              : null;

            if (mediaUrl) {
              const sendMediaData = new FormData();
              const senderId = currentUser.business_user_id || '17841463218981561';
              sendMediaData.append('user_id', currentUser.phone);
              sendMediaData.append('conversation_id', currentUser.conversation_id);
              sendMediaData.append('media_url', mediaUrl);
              sendMediaData.append('media_type', 'image');
              sendMediaData.append('platform', currentUser.platform);
              sendMediaData.append('recipient', currentUser.phone);
              sendMediaData.append('sender', senderId);

              await axios.post('https://jutiyapa.com/send_media/', sendMediaData);
            }
            setIsShowProgress(false);
          } catch (err) {
            console.error('Meta Image Upload Error', err);
            setIsShowProgress(false);
            setIsShowPopup(true);
          }
        } else {
          // WhatsApp Flow
          formData.append("image", selectedFile);
          formData.append("profile_name", currentUser.name);
          formData.append("phone_number", currentUser.phone);
          formData.append("from_number", currentUser.wb_num);

          axios.post('https://casualfootwears.com/api/upload_media/', formData, {
            onUploadProgress: (p) => {
              setIsShowProgress(true);
              setPercentage(Math.round((p.loaded * 100) / p.total));
            },
          })
            .then(() => setIsShowProgress(false))
            .catch((error) => {
              setIsShowProgress(false);
              setIsShowPopup(true);
              console.log("Error uploading image :: ", error);
            });
        }
      }
    };

    fileInput.click();
    setShowDropdown(false);
  };

  return (
    <>
      {isShowPopup && (
        <Popup
          setIsShowPopup={setIsShowPopup}
          popupMsg="Can't upload, Try again."
        />
      )}
      {isShowProgress && (
        <div className="ProgressContainer">
          <UploadProgress percentage={percentage} />
        </div>
      )}

      {popup && (
        <Popup
          setIsShowPopup={setPopup}
          popupMsg={"Error accessing microphone"}
        />
      )}
      <div className="chatFooterElements">
        <Buttons setInput={setInput} />

        {isMicOpen ? (
          <VoiceRecorder setMicOpen={setMicOpen} />
        ) : (
          <div className="whenMicNotOpen">
            <div>
              {openEmojiPicker && (
                <div className="emoji-picker-container">
                  <EmojiPicker onEmojiClick={handleEmojiSelect} />
                </div>
              )}

              <MicIcon
                className="emojiIcon"
                onClick={() => {
                  setMicOpen(true);
                }}
              />
              <MoodIcon
                className="emojiIcon"
                onClick={() => {
                  setOpenEmojiPicker(!openEmojiPicker);
                }}
              />
            </div>

            <textarea
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Send a message"
              onKeyDown={handleKeyPress}
              onInput={autoEx}
              ref={textarea}
            />

            <AddCircleIcon
              className="addIcon"
              onClick={() => setShowDropdown(!showDropdown)}
            />

            {showDropdown && (
              <div
                className="dropdown-menu"
                onClick={(e) => e.stopPropagation()}
              >
                <span className="dropdown-item" onClick={() => sendDocument()}>
                  <AttachmentIcon /> Send Document
                </span>
                <span className="dropdown-item" onClick={() => sendVideo()}>
                  <VideoCallIcon /> Send Video
                </span>
                <span className="dropdown-item" onClick={() => sendImage()}>
                  <ImageIcon /> Send Image
                </span>
              </div>
            )}

            <SendIcon className="sendIcon" onClick={sendMessage} />
          </div>
        )}
      </div>
    </>
  );
}

export default Footer;
